import React from 'react';

import Box from '@mui/material/Box';
import AppBar from '@mui/material/AppBar';
import Grid from '@mui/material/Grid';
import ArticleIcon from '@mui/icons-material/Article';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import CircularProgress from '@mui/material/CircularProgress';
import Alert from '@mui/material/Alert';

import { useTheme } from '@mui/material/styles';
import { useQuery } from '../hooks/useQuery';
import { useSnackbar } from '../hooks/useSnackbar';
import { encryptData, handleHttpError } from '../utils';
import { useAuth } from '../hooks/useAuth';
import { useNavigate } from 'react-router-dom';

const DadosBancarios = () => {
  const theme = useTheme();
  const snackbar = useSnackbar();
  const { cnpjSemPontos, user } = useAuth();
  const { obterFornecedorPorCnpj } = useQuery();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = React.useState(true);
  const [data, setData] = React.useState({
    agencia: '',
    conta: '',
    banco: '',
    digito: '',
  });

  React.useEffect(() => {
    buscarDadosFornecedor();
  }, []);

  const buscarDadosFornecedor = async () => {
    try {
      const { data: dataResponse } = await obterFornecedorPorCnpj(
        user.cnpj !== null ? cnpjSemPontos() : user.cpf,
      );

      setData({
        agencia: dataResponse.data.agenc_fornec,
        conta: dataResponse.data.ccorren_fornec,
        banco: dataResponse.data.nom_banco,
        digito: dataResponse.data.dig_cc_fornec,
      });
    } catch (error) {
      snackbar.showSnackbar(handleHttpError(error));
    } finally {
      setIsLoading(false);
    }
  };

  const onClickNavigate = () => {
    navigate(
      `/dashboard/cadastro-fornecedor?fornecedor_id=${encryptData(
        user.fornecedor_id,
      )}`,
    );
  };

  return (
    <Box
      mt={8}
      sx={{ width: '100%', background: '#FAFCFF', minHeight: '100vh' }}
    >
      <AppBar position="static" color="primary" style={{ padding: 10 }}>
        <Grid container spacing={0}>
          <Grid item xs={0.5}>
            <ArticleIcon
              sx={{ fontSize: 40, display: { xs: 'none', md: 'flex' }, mr: 1 }}
            />
          </Grid>
          <Grid item xs={11.5} alignItems="center" display="flex">
            <h3 style={{ color: 'white', margin: 0 }}>Meus dados bancários</h3>
          </Grid>
        </Grid>
      </AppBar>

      <Grid container spacing={1} paddingY="2rem" paddingX="1rem">
        <Grid item sm={12}>
          <Card
            variant="outlined"
            style={{
              borderTop: `8px solid ${theme.palette.primary.light}`,
            }}
          >
            <CardContent>
              {isLoading ? (
                <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                  <CircularProgress />
                </Box>
              ) : (
                <>
                  <Typography component="h5" variant="h5" color="primary">
                    Dados bancários
                  </Typography>
                  <Grid container spacing={2}>
                    <Grid item sm={12}>
                      <TextField
                        value={data.banco}
                        margin="normal"
                        disabled={true}
                        fullWidth
                        label="Banco"
                      />
                    </Grid>
                    <Grid item sm={6}>
                      <TextField
                        value={data.agencia}
                        margin="normal"
                        disabled={true}
                        fullWidth
                        label="Agência"
                      />
                    </Grid>
                    <Grid item sm={6}>
                      <TextField
                        value={data.digito}
                        margin="normal"
                        disabled={true}
                        fullWidth
                        label="Dígito"
                      />
                    </Grid>
                    <Grid item sm={6}>
                      <TextField
                        value={data.conta}
                        margin="normal"
                        disabled={true}
                        fullWidth
                        label="Conta"
                      />
                    </Grid>
                  </Grid>
                </>
              )}
              <br />
              <Alert variant="outlined" severity="primary">
                <Typography component="p">
                  Para alterar seus dados bancários, faça a atualização do seu
                  cadastro clicando{' '}
                  <span
                    onClick={onClickNavigate}
                    style={{
                      cursor: 'pointer',
                      color: '#0e72b8',
                    }}
                  >
                    AQUI
                  </span>
                  .
                </Typography>
              </Alert>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
};

export default DadosBancarios;
